export const TRANSLATION_KEY = 'builder.resume_editor.ai_review_panel'
